import { HTTP } from "@/shared/services/Http.service";
import type { ActualizarPerfilResponse, ActualizarPerfilRequest } from "../types/interfaces/ActualizarPerfil.interface";
import URL_API_GESTION_CASOS from "../utils/ApiUrl/GestionCasosApi";

const http = HTTP();

/**
 * Actualiza el perfil de Ciudadano a Abogado
 * @param data Datos con matrícula, fecha, justificación y archivo en base64
 * @returns Promise con la respuesta de la actualización
 */
export const actualizarPerfil = (data: ActualizarPerfilRequest): Promise<ActualizarPerfilResponse> => {
  const body = {
    MatriculaAbogado: data.matriculaAbogado,
    FechaMatricula: data.fechaMatricula,
    Justificacion: data.justificacion,
    ArchivoEvidencia: data.archivoEvidencia, //<-- base64 string
  }
  return http.Post(URL_API_GESTION_CASOS.ACTUALIZAR_PERFIL_CIUDADANO_ABOGADO, {
    body
  });
};
